import { useEffect, useState } from 'react';
import { getDataConnector, getDataConnectorGlobal } from '../../requests/request';
import { useAppSelector } from "../../../../../../redux/hooks";
import Pruebachart from './widgetconnectores';

export default function IpsecconnectorVert(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id);
  const tenant = useAppSelector(state => state.TenantSlice.id);
  const Cloud = useAppSelector(state => state.CloudSlice.Type);
  const nameregion = useAppSelector(state => state.RegionSlice.name);
  const FlagReg = useAppSelector(state => state.FlagSlice.value);

  const [DataAvailable, setDataAvailable] = useState({
    Available_DTR_VPN: 0,
    DateUpdate_DTR_VPN: '',
    exceeded_DTR_VPN: 0,
    Total_DTR_VPN: 1,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Cloud !== 'CloudGlobal') {
          const available = tenant === 0
            ? await getDataConnector(Id, props.source, Cloud, nameregion)
            : await getDataConnectorGlobal(Id, tenant, props.source, Cloud, nameregion);

          setDataAvailable(available.data);
        } else if (Id !== 0 && Id !== -1 && Cloud === 'CloudGlobal') {
          const available = tenant === 0
            ? await getDataConnector(Id, props.source)
            : await getDataConnectorGlobal(Id, tenant, props.source);

          setDataAvailable(available.data);
        }
      } catch (error) {
        console.error('Error al obtener la data:', error);
      }
    };

    fetchData();
  }, [Id, nameregion, props.id]);

  if (DataAvailable.Available_DTR_VPN === 0) {
    return null;
  }

  const chartColor = DataAvailable.exceeded_DTR_VPN !== 0 ? 'danger' : 'marino';

  return (
    <Pruebachart
      exedido={DataAvailable.exceeded_DTR_VPN}
      name='IPSec Connector'
      total={DataAvailable.Total_DTR_VPN}
      disponible={DataAvailable.Available_DTR_VPN}
      className='card-xl-stretch'
      chartColor={chartColor}
      chartHeight={300}
    />
  );
}
